import { trackTemplateOpened } from '@/lib/analytics/scribe/template';
import type { HandleEditTemplateHost } from '@heidi/templates';

// Call through so a suite mock of the analytics module is read at the call,
// not while this module is still loading.
export const handleEditTemplateHost = {
  trackTemplateOpened: (...args: Parameters<typeof trackTemplateOpened>) =>
    trackTemplateOpened(...args),
} satisfies HandleEditTemplateHost;
